import type {PreviewConfiguration} from 'schema/types';
import {defaultPreviewConfig} from './defaultPreviewConfig';

export const bulkUpdatePreviewConfig: PreviewConfiguration = {
  ...defaultPreviewConfig,
};
